import { render, staticRenderFns } from "./client_reporte.vue?vue&type=template&id=8d2a7a82&"
import script from "./client_reporte.vue?vue&type=script&lang=js&"
export * from "./client_reporte.vue?vue&type=script&lang=js&"
import style0 from "./client_reporte.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports